import { SourcePages, EventType, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

export type Directions = 'fwd' | 'bk';

export default class VdpPhotoSlideshowChangeEvent implements EventData {
  constructor(private direction: Directions) {}

  // eslint-disable-next-line camelcase
  event_type = EventType.engagement;

  // eslint-disable-next-line camelcase
  source_page = SourcePages.VdpPhotoSlideshow;

  feature = Features.slideshow;

  // eslint-disable-next-line camelcase
  get engagement_type(): string {
    return `scroll_${this.direction}`;
  }
}
